import * as wasm from "./symbol_crypto_wasm_bg.wasm";
import { __wbg_set_wasm } from "./symbol_crypto_wasm_bg.js";

__wbg_set_wasm(wasm);
wasm.__wbindgen_start();
export {
    HashMode, crypto_private_sign, crypto_private_verify, crypto_sign_keypair
} from "./symbol_crypto_wasm_bg.js";
export { wasm as __wasm }
